import React from "react";
import {
  Box,
  Stack,
  Typography,
  CircularProgress,
  Paper,
  Divider,
} from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import {
  FileExplorerProvider,
  useFileExplorerContext,
} from "../FileExplorerContext";
import { FileExplorerToolbar } from "./FileExplorerToolbar";
import { FileList } from "./FileList";
import { FileExplorerLoadingOverlay } from "./FileExplorerLoadingOverlay";
import { SelectFileTypeDropdown } from "../upload/SelectFileTypeDropdown";
import { AccountPageLayout } from "components/common/AccountPageLayout";

// Extend dayjs with relative time plugin
dayjs.extend(relativeTime);

const FileExplorerContent: React.FC = () => {
  const { t } = useTenantTranslation();
  const { files, isLoading } = useFileExplorerContext();

  if (isLoading && files.length === 0) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <Stack spacing={2} alignItems="center">
          <CircularProgress />
          <Typography variant="body1">{t("loadingFiles")}</Typography>
        </Stack>
      </Box>
    );
  }

  return (
    <AccountPageLayout title={t("fileExplorer")}>
      <Stack py={1} flex={1} spacing={3}>
        <SelectFileTypeDropdown />

        <Paper
          elevation={1}
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }}
        >
          <FileExplorerToolbar />
          <Divider />

          <FileList />

          <FileExplorerLoadingOverlay />
        </Paper>
      </Stack>
    </AccountPageLayout>
  );
};

export const FileExplorerPage: React.FC = () => {
  return (
    <FileExplorerProvider>
      <FileExplorerContent />
    </FileExplorerProvider>
  );
};
